export enum CreateGoodType {
Asset,
Good,
}
